import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '@/assets/common/store/store.ts'
import ApiClient from '@/assets/common/api-client/api-client.ts'
import Toasted from 'vue-toasted'
import vClickOutside from 'v-click-outside'
import VCalendar from 'v-calendar'; 
import inert from '@/directives/inert.ts'

Vue.use(VCalendar, { /* options */ });
Vue.config.productionTip = false
Vue.prototype.$apiClient = new ApiClient(store)
Vue.use(VueAxios, axios)
Vue.use(vClickOutside)
Vue.directive('inert', inert)

Vue.config.productionTip = false
Vue.prototype.$eventHub = new Vue();

const option = {
    position: 'bottom-right', // 表示場所
    duration: 3000,           // 表示時間(ms)
}

Vue.use(Toasted, option)

function init() {
  Vue.prototype.$apiClient.setTenantId()
  Vue.prototype.$apiClient.getAccessToken(
    ()=> Vue.prototype.$apiClient.getUserProfile()
    .then(()=>{
      new Vue({
        router,
        render: h => h(App),
        store,
      }).$mount('#app')
    })
  )
}

init()
